import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardHeader
} from '@material-ui/core';
import {
  BackdropCircular,
  Breadcrumb
} from 'components';
import {
  getAllBrandsApi,
  getQuoteProductApi,
  getQuoteProductSubscriptionOptionsApi
} from 'api';
import { clearEditableQuoteProductData } from 'redux/actions/quote';
import useStyles from './styles';
import QuoteProductDetails from './QuoteProductDetails';
import QuoteConfigurationsContainer from './QuoteConfiguration';


const QuoteProduct = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { sku } = useParams<{sku: string}>();

  const {
    editableQuoteProduct,
    quoteProductLoading,
  } = useSelector((state: IReduxState) => state.quote);

  const {
    allBrands,
    loadingAllBrands
  } = useSelector((state: IReduxState) => state.brands);

  useEffect(() => {
    getQuoteProductApi({dispatch, sku});
    getQuoteProductSubscriptionOptionsApi({dispatch, sku});

    if (!allBrands.length) {
      getAllBrandsApi({dispatch});
    }

    return () => {
      dispatch(clearEditableQuoteProductData());
    };
  }, [sku]);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Quote Listings', path: '/quoting/listings/active' },
            { name: editableQuoteProduct?.name }
          ]}
        />
      </div>
      {editableQuoteProduct &&
        <QuoteProductDetails editableQuoteProduct={editableQuoteProduct} />
      }
      <Card className="mx-10 my-5">
        <CardHeader
          title="Listing Configurations"
          className={classes.cardHeader}
        />
        <CardContent className="px-8 py-6">
          <QuoteConfigurationsContainer />
        </CardContent>
      </Card>
      <BackdropCircular loading={quoteProductLoading || loadingAllBrands} />
    </div>
  );
};

export default QuoteProduct;
